import { render, staticRenderFns } from "./ConfigServiceView.vue?vue&type=template&id=b01650be&"
import script from "./ConfigServiceView.vue?vue&type=script&lang=ts&"
export * from "./ConfigServiceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports